<div class="title">
    Data & Reports
</div>

<app-resources-table></app-resources-table>
